import type { ReactNode } from 'react';
import {
  Box,
  CheckCircle2,
  Clock,
  ShoppingCart,
  Truck,
} from 'lucide-react';
import {
  OrderFlowStepCard,
  SectionHeader,
  StatusCardSkeletonGrid,
} from '@/components/dashboard/DashboardCards';
import {
  ORDER_FLOW_STEPS,
  formatCount,
  statCount,
} from '@/components/dashboard/commandCenterConfig';
import { routes } from '@/routes/paths';
import type { OrderFlowStepKey, OrderStatistics } from '@/types/dashboard';

const STEP_ICONS: Record<OrderFlowStepKey, ReactNode> = {
  searching_for_dm: <Clock size={22} strokeWidth={1.85} />,
  accepted_by_dm: <ShoppingCart size={22} strokeWidth={1.85} />,
  preparing_in_rs: <Box size={22} strokeWidth={1.85} />,
  picked_up: <Truck size={22} strokeWidth={1.85} />,
  delivered: <CheckCircle2 size={22} strokeWidth={1.85} />,
};

export function OrderFlow({
  stats,
  loading,
}: {
  stats: OrderStatistics | undefined;
  loading: boolean;
}) {
  return (
    <section className="cmd-section" aria-label="Order flow">
      <SectionHeader title="Order Flow" />
      {loading && !stats ? (
        <StatusCardSkeletonGrid count={5} />
      ) : (
        <div className="flow-grid" role="list">
          {ORDER_FLOW_STEPS.map((step, index) => (
            <div className="flow-grid-cell" role="listitem" key={step.key}>
              <OrderFlowStepCard
                icon={STEP_ICONS[step.key]}
                label={step.label}
                value={formatCount(statCount(stats, step.key))}
                description={step.description}
                tone={step.tone}
                loading={loading}
                step={index + 1}
                to={routes.orders}
                search={{ status: step.statusQuery, page: 1, search: '' }}
              />
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
